import FormViewer from './viewers/FormViewer';
import ImageViewer from './viewers/ImageViewer';
import PdfViewer from './viewers/PdfViewer';
import React from 'react';
import requiresReview from './hocs/requiresReview';
import { download } from 'ducks/reviewDocuments';

import './styles/ReviewDocument.scss';
import PropTypes from 'prop-types';

// common mimetypes: https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types#image_types
const ImageTypes = ['image/apng', 'image/avif', 'image/gif', 'image/jpeg', 'image/png', 'image/svg+xml', 'image/webp'];

// Renders viewer component appropriate for the given document
const Viewer = ({ document }) => {
  if (document.document_type === 'file' && document.mime_type === 'application/pdf') {
    return <PdfViewer document={document}/>;
  } else if (document.document_type === 'file' && ImageTypes.indexOf(document.mime_type) !== -1) {
    return <ImageViewer document={document}/>;
  } else if (document.document_type === 'form') {
    return <FormViewer document={document}/>;
  } else {
    return <div className="review-documents-not-supported">
      <div className="alert alert-info">
        <p>This type of file cannot be displayed here. Please download it and open it on your computer.</p>
        <button className="btn btn-primary" onClick={() => download(document)}>Download {document.name}</button>
      </div>
    </div>;
  }
};

/**
 * Displays a review document, whether a form, PDF, image or arbitrary file upload.
 *
 * @param params route parameters from react-router
 * @param reviewContext the review context object
 * @return {JSX.Element}
 */
const ReviewDocument = ({ params, reviewContext }) => {
  const { documentKey } = params;
  const { documents } = reviewContext;
  const document = documents.find(doc => doc.key === documentKey);

  return <div className="review-documents">
    <h2>{document.name}</h2>

    {!document.available && <div className="review-documents-not-available">
      <div className="alert alert-info">
        The document for {document.name} has not been submitted by the applicant.
      </div>
    </div>}

    {document.available && <Viewer document={document}/>}
  </div>;
};

ReviewDocument.propTypes = {
  params: PropTypes.shape({
    documentKey: PropTypes.string,
  }),
};

export default requiresReview(ReviewDocument);
